import axios from 'axios';
import BaseAPI from './base/base-api';

class OrganizationTransferInvoiceAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'organizationtransferinvoice';
}

export default new OrganizationTransferInvoiceAPI();